import React from 'react'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import { fixTableStructure, htmlDecode } from '../../../utils/html'
import type { ActionProps } from '../../modernBlocks.state'
import { SharedBlockLayout } from '../shared/sharedBlock.layout'
import type { TextBlockClassNames } from './textBlock.state'
import { slugify } from '../../../../../../Shared/Frontend/utils/slugify'

export const textBlockClasses: TextBlockClassNames = {
  // DEFAULTS
  block: 'block block--text',
  inview: 'inview',
  inner: 'block__inner ls-container ls-gutter ls-spacing--s',
  header: 'block__header',
  label: 'block__label text--s',
  title: 'block__title title--m',
  intro: 'block__intro text--l',
  content: 'block__content',
  text: 'block__text text--styled',
  footer: 'block__footer ls-clickables',
  clickableWrapper: 'block__action ls-clickable',
  clickablePrimary: 'block__button button button--primary',
  clickableSecondary: 'block__button button button--tertiary',

  // BLOCK SPECIFIC
}

export const TextBlockLayout = {
  Inner: (props: {
    id?: string,
    children?: React.ReactNode,
    amountNested: number,
  }): JSX.Element => {
    const { amountNested, children, id } = props
    return (
      <div className={getClassNameModern(textBlockClasses, 'inner', 'mw-container-s mx-auto px-gutter')}>{children}</div>
    )
  },
  Content: (props: {
    label?: string,
    title?: string,
    intro?: string,
    text: string
    showActionAsLink: boolean
  } & ActionProps) => {
    const {
      label,
      title,
      intro,
      text,
      showPrimary,
      showSecondary,
      primaryAction,
      secondaryAction,
      showActionAsLink,
    } = props
    return (
      <>
        {(label || title || intro) && (
          <header className={getClassNameModern(textBlockClasses, 'header', '')}>
            {label &&
              <p className={getClassNameModern(textBlockClasses, 'label', 'fs-6 text-primary text-uppercase')}>{label}</p>
            }
            {title &&
              <h2 id={slugify(htmlDecode(title))} className={getClassNameModern(textBlockClasses, 'title', 'h2 mb-3')}>{title}</h2>
            }
            {intro &&
              <div
                className={getClassNameModern(textBlockClasses, 'intro', 'text--styled lead mb-3')}
                dangerouslySetInnerHTML={{ __html: intro }}
              />
            }
          </header>
        )}
        {text && (
          <div className={getClassNameModern(textBlockClasses, 'content', '')}>
            <div
              className={getClassNameModern(textBlockClasses, 'text', 'text--styled')}
              dangerouslySetInnerHTML={{ __html: fixTableStructure(text) }}
            />
          </div>
        )}
        {(showPrimary || showSecondary) && (
          <footer className={getClassNameModern(textBlockClasses, 'footer', 'pt-5')}>
            {showPrimary && primaryAction && primaryAction.title && primaryAction.url && (
              <div className={getClassNameModern(textBlockClasses, 'clickableWrapper', 'd-block d-sm-inline-block')}>
                <SharedBlockLayout.Clickable
                  id='textPrimaryAction'
                  type='button'
                  link={primaryAction}
                  classNames={getClassNameModern(textBlockClasses, showActionAsLink === true ? 'clickableSecondary' : 'clickablePrimary', 'btn btn-primary')}
                />
              </div>
            )}
            {showSecondary && secondaryAction && secondaryAction.title && secondaryAction.url && (
              <div
                className={getClassNameModern(
                  textBlockClasses,
                  'clickableWrapper',
                  'd-block d-sm-inline-block ms-sm-3 mt-3 mt-sm-0'
                )}
              >
                <SharedBlockLayout.Clickable
                  id='textSecondaryAction'
                  type='button'
                  link={secondaryAction}
                  classNames={getClassNameModern(textBlockClasses, 'clickableSecondary', 'btn btn-outline-primary')}
                />
              </div>
            )}
          </footer>
        )}
      </>
    )
  }
}
